<template>
<div class="ew-page">
  <navbar-dashboard name="Direcciones"></navbar-dashboard>

  <div class="ew-page__body">
    <div class="ew-toolbar ew-toolbar--end">
      <button class="ew-btn-primary" @click="showModal('')">Nueva dirección</button>
    </div>

    <b-modal ref="addAddress" hide-footer v-bind:title="title" modal-class="ew-modal">
      <form @submit.prevent="saveAddress" class="ew-form">
        <div class="ew-form__field">
          <label class="ew-label" for="a-name">Nombre y apellido *</label>
          <input id="a-name" type="text" class="ew-input ew-input--block" placeholder="Nombre y apellido" v-model="name" required>
        </div>
        <div class="ew-form__field">
          <label class="ew-label" for="a-phone">Teléfono *</label>
          <input id="a-phone" type="text" class="ew-input ew-input--block" placeholder="(442) 123 12 45" v-model="phone" required>
        </div>
        <div class="ew-form__field">
          <label class="ew-label" for="a-email">Correo *</label>
          <input id="a-email" type="email" class="ew-input ew-input--block" placeholder="correo@ejemplo.com" v-model="email" required>
        </div>
        <div class="ew-form__field">
          <label class="ew-label" for="a-street">Calle *</label>
          <input id="a-street" type="text" class="ew-input ew-input--block" placeholder="Av. Felipe Ángeles" v-model="address" required>
        </div>
        <div class="ew-form__row">
          <div class="ew-form__field">
            <label class="ew-label" for="a-number">No. Ext *</label>
            <input id="a-number" type="text" class="ew-input ew-input--block" placeholder="511" v-model="number" required>
          </div>
          <div class="ew-form__field">
            <label class="ew-label" for="a-int">No. Int</label>
            <input id="a-int" type="text" class="ew-input ew-input--block" placeholder="J-501" v-model="intNumber">
          </div>
        </div>
        <div class="ew-form__field">
          <label class="ew-label" for="a-ref">Referencia <small>(opcional)</small></label>
          <input id="a-ref" type="text" class="ew-input ew-input--block" placeholder="Entre calles, color de fachada, etc." v-model="reference_of_origin">
        </div>

        <div class="ew-form__field ew-form__field--relative">
          <label class="ew-label" for="a-cp">Código postal *</label>
          <input
            id="a-cp"
            type="text"
            autocomplete="off"
            class="ew-input ew-input--block"
            placeholder="C.P."
            v-model="origin.input"
            @keyup="checkAddressOrigin"
            @keyup.down="onArrowDown"
            @keyup.up="onArrowUp"
            @keyup.enter="onEnter"
            required
          >
          <ul class="ew-autocomplete" v-if="isLoading" v-show="isOpen" id="autocomplete-results-das">
            <li
              id="resultOrigin"
              v-for="(result, i) in results"
              :key="i"
              @click="setResult(result)"
              class="ew-autocomplete__item"
              :class="{ 'is-active': i === arrowCounter }"
            >{{result.postal_code + ' - ' + result.place_name + ' - ' + result.city}}</li>
          </ul>
        </div>

        <div class="ew-form__row">
          <div class="ew-form__field">
            <label class="ew-label" for="a-colony">Colonia *</label>
            <input id="a-colony" type="text" class="ew-input ew-input--block" placeholder="Según C.P." disabled v-model="colony" required>
          </div>
          <div class="ew-form__field">
            <label class="ew-label" for="a-city">Ciudad *</label>
            <input id="a-city" type="text" class="ew-input ew-input--block" placeholder="Según C.P." disabled v-model="city" required>
          </div>
          <div class="ew-form__field">
            <label class="ew-label" for="a-country">País *</label>
            <input id="a-country" type="text" class="ew-input ew-input--block" placeholder="Según C.P." disabled v-model="country_code" required>
          </div>
        </div>

        <div class="ew-modal__actions">
          <button type="button" class="ew-btn-outline" @click="hideModal">Cancelar</button>
          <button class="ew-btn-primary" type="submit">Guardar cambios</button>
        </div>
      </form>
    </b-modal>

    <section class="ew-card">
      <div class="table-responsive">
        <div class="ew-loading" v-if="dataLoading">
          <span class="ew-spinner"></span>
          <p class="ew-loading-text">Cargando direcciones…</p>
        </div>
        <table class="ew-table" v-else-if="locations.length > 0">
          <thead>
            <tr>
              <th scope="col">Nombre</th>
              <th scope="col">Teléfono</th>
              <th scope="col">Correo</th>
              <th scope="col">Dirección</th>
              <th scope="col">Referencia</th>
              <th scope="col">Colonia</th>
              <th scope="col">Ciudad</th>
              <th scope="col">C.P.</th>
              <th scope="col">País</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(d, i) in locations" v-bind:key="i">
              <td>{{ d.name }}</td>
              <td>{{ d.phone }}</td>
              <td>{{ d.email }}</td>
              <td>{{ d.address }}</td>
              <td>{{ d.reference_of_origin }}</td>
              <td>{{ d.colony }}</td>
              <td>{{ d.city }}</td>
              <td>{{ d.postal_code }}</td>
              <td>{{ d.country_code }}</td>
              <td class="ew-table__actions">
                <button class="ew-table__link-btn" @click="editAddress(d._id)">Editar</button>
                <button class="ew-table__link-btn ew-table__link-btn--danger" @click="removeAddress(d._id)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="ew-empty" v-else>
          <ph-icon name="address-book" />
          <p class="ew-empty__title">Aún no tienes direcciones</p>
          <p class="ew-empty__text">Guarda una dirección para reutilizarla en tus próximos envíos.</p>
          <button class="ew-btn-primary" @click="showModal('')">Agregar dirección</button>
        </div>
      </div>
    </section>
  </div>
</div>
</template>

<script>
import Navbar from './Header/Navbar'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import api from '../commons/api'
import axios from 'axios'
import commons from '../commons'
import VueConfirmDialog from 'vue-confirm-dialog'
import Vue from 'vue'
import PhIcon from './icons/PhIcon'

Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

export default {
  name: 'Addresses',
  data () {
    return {
      title: 'Nueva dirección',
      id: '',
      name: '',
      phone: '',
      email:'',
      address: '',
      number: '',
      intNumber: '',
      reference_of_origin: '',
      colony: '',
      postal_code: '',
      city: '',
      country_code: 'MX',
      user_id: '',
      locations: [],
      isOpen: false,
      results: [],
      scroll:0,
      isLoading: false,
      dataLoading: true,
      arrowCounter: -1,
      origin: {
        flag: "https://restcountries.eu/data/mex.svg",
        country_code: 'MX',
        input: ''
      },
    }
  },
  created () {
    this.user_id = localStorage.getItem('ew-user-id')
    this.getLocationsUser()
    this.setItemActive('addresses')
  },
  mounted(){

  },
  beforeDestroy(){

  },
  methods: {
   ...mapMutations(['setItemActive']),

   showModal (id) {
     this.id = id
     if(id == '')
     {
       this.name = ''
       this.phone = ''
       this.email = ''
       this.address = ''
       this.number = ''
       this.intNumber = ''
       this.colony = ''
       this.reference_of_origin = ''
       this.origin.input = ''
       this.postal_code = ''
       this.city = ''
       this.country_code = 'MX'
       this.title= 'Nueva dirección'
     }
     else
     {
        this.title = 'Editar dirección'
     }
     this.$refs.addAddress.show()
   },
   hideModal () {
     this.$refs.addAddress.hide()
   },
   saveAddress () {
      if(this.id == '')
      {
        this.registerAdress()
      }
      else
      {
        this.updateAddress()
      }
   },
   registerAdress()
   {
     axios
       .post(`${commons.apiURL}/api/v1/locations-user`, {
         name: this.name,
         email: this.email,
         phone: this.phone,
         address: this.address + ', ' +  this.number + (this.intNumber.length > 0 ? ', ' + this.intNumber : ''),
         colony: this.colony,
         reference_of_origin: this.reference_of_origin,
         postal_code: this.postal_code,
         city: this.city,
         user: this.user_id,
         country_code: this.country_code
       })
       .then(response => {
           if(response.status == 200)
           {
              this.hideModal()
              this.getLocationsUser()
           }
       })
       .catch(error => {
         console.error(error)
       })
   },
   updateAddress()
   {
     axios
       .put(`${commons.apiURL}/api/v1/locations-user/${this.id}`, {
         name: this.name,
         email: this.email,
         phone: this.phone,
         address: this.address + ', ' +  this.number + (this.intNumber.length > 0 ? ', ' + this.intNumber : ''),
         reference_of_origin: this.reference_of_origin,
         colony: this.colony,
         postal_code: this.postal_code,
         city: this.city,
         user: this.user_id,
         country_code: this.country_code
       })
       .then(response => {
           if(response.status == 200)
           {
              this.hideModal()
              this.getLocationsUser()
           }
       })
       .catch(error => {
         console.error(error)
       })
   },
   removeAddress(id)
   {
     this.$confirm({
       title: '¿Está seguro?',
       message: '¿Está seguro de eliminar este registro?',
       button: {
         yes: 'Sí',
         no: 'Cancelar'
       },
       callback: confirm => {
         if (confirm) {
           axios
             .delete(`${commons.apiURL}/api/v1/locations-user/${id}`)
             .then(response => {
                 if(response.status == 200)
                 {
                    this.hideModal()
                    this.getLocationsUser()
                 }
             })
             .catch(error => {
               console.error(error)
             })
             }
             else
             {

             }
         }
       })
   },
   getLocationsUser () {
     axios
       .get(`${commons.apiURL}/api/v1/locations-user?user=${this.user_id}`)
       .then(response => {
           this.locations = response.data
       })
       .catch(error => {
         console.error(error)
       })
       .finally(() => {
         this.dataLoading = false
       })
   },
   editAddress (id) {
      axios
       .get(`${commons.apiURL}/api/v1/locations-user/${id}`)
       .then(response => {
           var address = response.data.address.split(',')
           this.name =  response.data.name
           this.email = response.data.email
           this.phone = response.data.phone
           this.address = address[0]
           this.number = address.length > 1 ?  address[1] : ''
           this.intNumber = address.length > 2 ?  address[2] : ''
           this.reference_of_origin =response.data.reference_of_origin
           this.colony = response.data.colony
           this.postal_code = response.data.postal_code
           this.origin.input = response.data.postal_code
           this.city = response.data.city
           this.country_code = response.data.country_code
           this.showModal(id)
       })
       .catch(error => {
         console.error(error)
       })
   },
   checkAddressOrigin (event) {
     // console.log(event)
     const query = event.target.value
     if (query.length >= 3 &&  query.length <= 7) {
       this.getLocationInfo(query, 'MX').then(response => {

         this.results = response.data.country_codes
         if (this.results.length > 0) {
           this.isOpen= true
           this.isLoading = true
         } else {
           this.isOpen= false
           this.isLoading = false
         }
       })
     }
   },
   getLocationInfo (zipCode, countryCode) {
     return axios.get(
       `${
         commons.apiURL
       }/api/v1/postalcodes?search=${zipCode}&country=${countryCode}`
     )
   },
   handleClickOutside(evt) {

     if (evt.target.id !== "resultOrigin") {
       this.isOpen = false;
       this.isLoading = false;
       this.arrowCounter = 0;
       this.scroll = 0;
     }
   },
   onArrowDown() {
     try {

       if (this.arrowCounter <= this.results.length - 1 && this.isOpen) {
         if (this.arrowCounter === this.results.length - 1) {
           this.scroll = 0
           this.arrowCounter = 0;
           this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
           this.scrollTo(this.scroll);
         } else {
           if (this.arrowCounter < 0) {
             this.arrowCounter = this.arrowCounter + 1;
             this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
             this.scroll = 0
             this.scrollTo(this.scroll);
           } else {
             this.arrowCounter = this.arrowCounter + 1;
             this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
             this.scroll = this.scroll + 30

             this.scrollTo(this.scroll);
           }
         }
     }

     if (this.arrowCounter > this.results.length -1 && this.isOpen) {
       this.arrowCounter = 0;
     }

     } catch (error) {
       console.log("Jesus", error)
     }
   },
   onArrowUp() {


       if (this.arrowCounter === 0) {
           this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
           this.arrowCounter = this.arrowCounter - 1;
           this.scroll = this.scroll - 30
           this.scrollTo(this.scroll);
       }

       if (this.arrowCounter > 0 && this.isOpen) {
         this.arrowCounter = this.arrowCounter - 1;
         this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
         this.scroll = this.scroll - 30
         this.scrollTo(this.scroll);

       }

       if (this.arrowCounter < 0 && this.isOpen) {
         this.arrowCounter = this.results.length -1;
         this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
         this.scroll = (30 * this.results.length -1 ) - 30
         this.scrollTo(this.scroll);
       }


   },
   onEnter() {

     this.origin.input = this.results[this.arrowCounter].postal_code;
     this.postal_code = this.results[this.arrowCounter].postal_code
     this.colony = this.results[this.arrowCounter].place_name
     this.city = this.results[this.arrowCounter].city
     this.isOpen = false;
     this.arrowCounter = -1;
   },
   setResult(result) {

     this.origin.input = result.postal_code;
     this.postal_code = result.postal_code
     this.colony = result.place_name
     this.city = result.city
     this.isOpen = false;
   },
   scrollTo(coord){

     let element = document.getElementById('autocomplete-results-das');
     element.scrollTo(0,coord)
   },
  },
  computed: {
   ...mapGetters(['itemActive'])
  },
  components: {
    'navbar-dashboard': Navbar,
    PhIcon
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-page { @include app-tokens; }
.ew-page__body { padding: 1.75rem 2rem 2.5rem; }

.ew-toolbar { margin-bottom: 1rem; &.ew-toolbar--end { display: flex; justify-content: flex-end; } }
.ew-btn-primary { @include ew-btn-primary; }
.ew-btn-outline { @include ew-btn-outline; }

.ew-card { @include ew-card; }
.ew-table { @include ew-table; }
.ew-loading { @include ew-loading; }
.ew-loading-text { @include ew-loading-text; }
.ew-spinner { @include ew-spinner; }
.ew-table__actions { white-space: nowrap; }
.ew-table__link-btn {
  border: none; background: none; padding: 0; margin-right: 1rem;
  font-family: var(--app-font); font-size: 0.8rem; font-weight: 700;
  color: var(--app-accent-button);
  &:hover { text-decoration: underline; }
  &--danger { color: #C8102E; }
}

.ew-empty { @include ew-empty; }
.ew-empty__title { @include ew-empty-title; }
.ew-empty__text { @include ew-empty-text; }

.ew-form { display: flex; flex-direction: column; gap: 1rem; max-width: none; /* App.vue trae un .ew-form global con max-width:400px legado de los formularios de auth viejos; sin este reset se hereda igual (misma especificidad, propiedades distintas) */ }
.ew-form__row { display: flex; flex-wrap: wrap; gap: 1rem; > .ew-form__field { flex: 1 1 160px; min-width: 0; } }
.ew-form__field { display: flex; flex-direction: column; gap: 0.4rem; }
.ew-form__field--relative { position: relative; }
.ew-label { font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-navy); }
.ew-input { @include ew-input; }
.ew-input--block { width: 100%; }
.ew-modal__actions { display: flex; justify-content: flex-end; gap: 0.6rem; }

.ew-autocomplete {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 20;
  margin: 0.25rem 0 0;
  padding: 0.25rem;
  list-style: none;
  max-height: 12rem;
  overflow-y: auto;
  background: #fff;
  border: 1px solid var(--app-border);
  border-radius: var(--app-radius-sm);
  box-shadow: 0 12px 28px rgba(7, 50, 88, 0.12);
}
.ew-autocomplete__item {
  padding: 0.5rem 0.6rem;
  border-radius: var(--app-radius-sm);
  font-family: var(--app-font);
  font-size: 0.85rem;
  color: var(--app-navy-secondary);
  cursor: pointer;
  &:hover,
  &.is-active {
    background: var(--app-surface-muted);
    color: var(--app-navy);
  }
}
</style>

<style lang="scss">
@import "../assets/styles/app-tokens";
.ew-modal {
  .modal-content { border-radius: 0.85rem; border: none; }
  .modal-header { border-bottom: 1px solid $app-border; }
  .modal-title { font-family: $app-font-family; font-weight: 700; color: $app-navy; }
}
</style>



// WEBPACK FOOTER //
// src/components/Addresses.vue